module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('steps', {
    attrs: {
      "currentStep": _vm.currentStep
    },
    on: {
      "switchStep": _vm.switchStep
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-product"
  }, [_c('div', {
    staticClass: "my-4"
  }, [(_vm.step === _vm.currentStep) ? _c('div', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.switchStep.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-end align-items-center border-bottom-light my-4 p-4"
  }, [(_vm.getSelectedItem != null) ? _c('button', {
    staticClass: "btn blue wider mr-3",
    attrs: {
      "disabled": _vm.$v.form.$invalid
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-2"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "disabled": _vm.$v.form.$invalid
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "disabled": _vm.$v.form.$invalid
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "px-4"
  }, [_c('div', {
    staticClass: "panel shaded"
  }, [_c('h5', {
    staticClass: "mt-5"
  }, [_vm._v("Prices")]), _vm._v(" "), (_vm.taxes) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Tax")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.taxes,
      "label": "description",
      "placeholder": "- Select tax -"
    },
    on: {
      "input": _vm.updateTax
    },
    model: {
      value: (_vm.selectedTax),
      callback: function($$v) {
        _vm.selectedTax = $$v
      },
      expression: "selectedTax"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 d-flex align-items-center"
  }, [_c('label', {
    staticClass: "full mt-3 normal"
  }, [_c('checkbox', {
    model: {
      value: (_vm.form.includeTaxes),
      callback: function($$v) {
        _vm.$set(_vm.form, "includeTaxes", $$v)
      },
      expression: "form.includeTaxes"
    }
  }, [_vm._v("\n                                            Price include taxes.\n                                        ")])], 1)])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.form.prices), function(price, index) {
    return _c('div', {
      staticClass: "form-group row mt-5"
    }, [_c('div', {
      staticClass: "col-sm-5"
    }, [_vm._m(0, true), _vm._v(" "), (_vm.types) ? _c('v-select', {
      attrs: {
        "options": _vm.types,
        "label": "description",
        "placeholder": "- Select type -"
      },
      on: {
        "input": function($event) {
          return _vm.updateType(price)
        }
      },
      model: {
        value: (price.selectedType),
        callback: function($$v) {
          _vm.$set(price, "selectedType", $$v)
        },
        expression: "price.selectedType"
      }
    }) : _vm._e()], 1), _vm._v(" "), (_vm.isPerson) ? _c('div', {
      staticClass: "col-sm-3"
    }, [_c('label', {
      staticClass: "full"
    }, [_vm._v(" ")]), _vm._v(" "), (_vm.audienceTypes) ? _c('v-select', {
      attrs: {
        "options": _vm.audienceTypes,
        "label": "description",
        "placeholder": "- Select person -"
      },
      on: {
        "input": function($event) {
          return _vm.updateAudienceType(price)
        }
      },
      model: {
        value: (price.selectedAudienceType),
        callback: function($$v) {
          _vm.$set(price, "selectedAudienceType", $$v)
        },
        expression: "price.selectedAudienceType"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-sm-2",
      class: {
        error: _vm.$v.form.prices.$each[index].value.$error
      }
    }, [_c('label', {
      staticClass: "full"
    }, [_vm._v("\n                                         \n                                        "), _c('div', {
      staticClass: "d-flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (price.value),
        expression: "price.value"
      }],
      staticClass: "glued-right",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (price.value)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(price, "value", $event.target.value)
        }, _vm.$v.form.prices.$each[index].value.$touch]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "glued-left"
    }, [_vm._v("€")])])]), _vm._v(" "), (_vm.$v.form.prices.$each[index].value.$error) ? _c('div', {
      staticClass: "messages"
    }, [(!_vm.$v.form.prices.$each[index].value.required) ? _c('span', [_vm._v("Price is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.form.prices.$each[index].value.withParams) ? _c('span', [_vm._v("Price must be a number.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (index > 0) ? _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', {
      staticClass: "full"
    }, [_vm._v(" ")]), _vm._v(" "), _c('i', {
      staticClass: "ico-delete largest medium align-items-bottom pointer",
      on: {
        "click": function($event) {
          return _vm.deleteRow(index)
        }
      }
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.hasAddRow) ? _c('div', {
    staticClass: "add d-flex align-items-center pointer fs-small bold",
    on: {
      "click": _vm.addRow
    }
  }, [_c('i', {
    staticClass: "ico-add fs-smallest add-circle color-1"
  }), _vm._v(" Add new price\n                            ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center border-top-light my-4 p-4"
  }, [(_vm.getSelectedItem != null) ? _c('button', {
    staticClass: "btn blue wider mr-3",
    attrs: {
      "disabled": _vm.$v.form.$invalid
    },
    on: {
      "click": _vm.prevStep
    }
  }, [_c('i', {
    staticClass: "ico-arrow-left fs-normal ml-2"
  }), _vm._v(" Back")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn cancel wider mr-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.getSelectedItem !== null) ? _c('button', {
    staticClass: "btn green wider mr-3",
    attrs: {
      "disabled": _vm.$v.form.$invalid
    },
    on: {
      "click": _vm.readyToSave
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "disabled": _vm.$v.form.$invalid
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "ico-arrow-right fs-normal ml-2"
  })])])])]) : _vm._e()])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "full"
  }, [_vm._v("Product pricing "), _c('span', {
    staticClass: "brand"
  }, [_vm._v("*")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-263f1592", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-263f1592"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/ProductPrices.vue
// module id = 1586
// module chunks = 0